import { Brand, Program } from '..';

const ExpediaPrograms: Record<string, Program> = {
  'au-expedia': {
    id: 'au-expedia',
    name: 'Expedia AU',
    brand: Brand.EXPEDIA,
    posa: 'AU',
    currency: 'AUD',
    locale: {
      baseName: 'en_AU',
      langId: 3081,
    },
  },

  'ca-expedia': {
    id: 'ca-expedia',
    name: 'Expedia CA',
    brand: Brand.EXPEDIA,
    posa: 'CA',
    currency: 'CAD',
    locale: {
      baseName: 'en_CA',
      langId: 4105,
    },
  },

  'de-expedia': {
    id: 'de-expedia',
    name: 'Expedia DE',
    brand: Brand.EXPEDIA,
    posa: 'DE',
    currency: 'EUR',
    locale: {
      baseName: 'de_DE',
      langId: 1031,
    },
  },

  'fr-expedia': {
    id: 'fr-expedia',
    name: 'Expedia FR',
    brand: Brand.EXPEDIA,
    posa: 'FR',
    currency: 'EUR',
    locale: {
      baseName: 'fr_FR',
      langId: 1036,
    },
  },

  'hk-expedia': {
    id: 'hk-expedia',
    name: 'Expedia HK',
    brand: Brand.EXPEDIA,
    posa: 'HK',
    currency: 'HKD',
    locale: {
      baseName: 'zh_HK',
      langId: 3076,
    },
  },

  'jp-expedia': {
    id: 'jp-expedia',
    name: 'Expedia JP',
    brand: Brand.EXPEDIA,
    posa: 'JP',
    currency: 'JPY',
    locale: {
      baseName: 'ja_JP',
      langId: 1041,
    },
  },

  'kr-expedia': {
    id: 'kr-expedia',
    name: 'Expedia KR',
    brand: Brand.EXPEDIA,
    posa: 'KR',
    currency: 'KRW',
    locale: {
      baseName: 'ko_KR',
      langId: 1042,
    },
  },

  'mx-expedia': {
    id: 'mx-expedia',
    name: 'Expedia MX',
    brand: Brand.EXPEDIA,
    posa: 'MX',
    currency: 'MXN',
    locale: {
      baseName: 'es_MX',
      langId: 2058,
    },
  },

  'nz-expedia': {
    id: 'nz-expedia',
    name: 'Expedia NZ',
    brand: Brand.EXPEDIA,
    posa: 'NZ',
    currency: 'NZD',
    locale: {
      baseName: 'en_NZ',
      langId: 3081,
    },
  },

  'sg-expedia': {
    id: 'sg-expedia',
    name: 'Expedia SG',
    brand: Brand.EXPEDIA,
    posa: 'SG',
    currency: 'SGD',
    locale: {
      baseName: 'en_SG',
      langId: 2057,
    },
  },

  'uk-expedia': {
    id: 'uk-expedia',
    name: 'Expedia UK',
    brand: Brand.EXPEDIA,
    posa: 'GB',
    currency: 'GBP',
    locale: {
      baseName: 'en_GB',
      langId: 2057,
    },
  },

  'us-expedia': {
    id: 'us-expedia',
    name: 'Expedia USA',
    brand: Brand.EXPEDIA,
    posa: 'US',
    currency: 'USD',
    locale: {
      baseName: 'en_US',
      langId: 1033,
    },
  },
};

export { ExpediaPrograms };
